import axios from "axios";
import ObjectUtil from "../../../../utils/common/ObjectUtil";
import {ordersServicesPath} from "../../../../Constants";

const estimateRestUrl = ordersServicesPath + '/organizations/estimates'

export default class EstimateService {

    static async setPurchaseByIds(ids, ignoreSlab) {
        let data = ObjectUtil.createRequestObjectIds(ids);
        return await axios.patch(estimateRestUrl + '/set-purchase-by-order-ids?ignoreSlab=' + ignoreSlab, JSON.stringify(data),
            {
                headers: {
                    'Content-Type': 'application/json'
                }
            });
    }

    static async createReservesForPurchaseByIds(ids, ignoreSlab) {
        let data = ObjectUtil.createRequestObjectIds(ids);
        return await axios.patch(estimateRestUrl + '/create-reserves-for-purchase-by-order-ids?ignoreSlab=' + ignoreSlab, JSON.stringify(data),
            {
                headers: {
                    'Content-Type': 'application/json'
                }
            }
        );
    }

    static async getAllByOrderId(id) {
        return axios.get(estimateRestUrl + '/order/' + id);
    }

    static async confirmExecution(orderId) {
        return await axios.patch(estimateRestUrl + '/confirm-execution?orderId=' + orderId, [], {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async confirmExecutionComposition(orderId) {
        return await axios.patch(estimateRestUrl + '/confirm-execution-composition?orderId=' + orderId, [], {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async setWithoutAccessor(orderId) {
        return await axios.patch(estimateRestUrl + '/set-without-accessories?orderId=' + orderId, [], {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async getAllNotCalculationAndNotArchive() {
        return axios.get(estimateRestUrl + '/get-all-not-calculation-not-archive');
    }

    static async save(id, data) {
        return await axios.patch(estimateRestUrl + "/" + id, JSON.stringify(data), {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async delete(id) {
        await axios.delete(estimateRestUrl + '/' + id);
    }

    static async unableCurrent(id, orderId) {
        return axios.patch(estimateRestUrl + '/' + id + '/unable-current' + '?orderId=' + orderId, [], {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async setPurchase(orderId, data, ignoreSlab = false) {
        return axios.patch(estimateRestUrl + '/set-purchase' + '?orderId=' + orderId + '&ignoreSlab=' + ignoreSlab, data, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async createReservesForPurchase(orderId, data, ignoreSlab, estimateId) {
        return axios.patch(estimateRestUrl + '/create-reserves-for-purchase' + '?orderId=' + orderId + '&estimateId=' + estimateId + "&ignoreSlab=" + ignoreSlab, data, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async createReserves(orderId, data, estimateId, ignoreSlab) {
        return axios.patch(estimateRestUrl + '/create-reserves' + '?orderId=' + orderId + '&estimateId=' + estimateId + "&ignoreSlab=" + ignoreSlab, data, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }


    static async setInWork(orderId) {
        return axios.patch(estimateRestUrl + '/set-in-work' + '?orderId=' + orderId, [], {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async returnInCalculation(id) {
        return axios.patch(estimateRestUrl + '/' + id + '/return-in-calculation', [], {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async setStatus(ids, estimateState) {
        let data = ObjectUtil.createRequestObjectIds(ids);
        return axios.patch(estimateRestUrl + '/set-estimate-state' + '?estimateState=' + estimateState, JSON.stringify(data), {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async getAllIdsModelByEstimateId(estimateId) {
        return axios.get(estimateRestUrl + '/ids-model-by-estimate' + '?estimateId=' + estimateId);
    }
}